import { Channel } from "models/ChannelModel";

export function sortChannels(value: Channel[]): Channel[] {
    return value?.sort((a: Channel, b: Channel) => {
        const groupA = a?.group || "";
        const groupB = b?.group || "";
        const groupComparison = groupA.localeCompare(groupB);
        if (groupComparison === 0) {
            return a.name.localeCompare(b.name);
        }
        return groupComparison;
    });
}
